exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".content[data-v-2b5cf64e]{padding:30px}.charts[data-v-2b5cf64e]{display:flex;flex-flow:wrap;margin-top:20px}.chart[data-v-2b5cf64e]{width:50%;height:500px;margin-bottom:50px}", ""]);

// exports
